var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var GoogleAnalyticsService = /** @class */ (function () {
    function GoogleAnalyticsService() {
    }
    GoogleAnalyticsService.loadJs = function (trackId) {
        var _this = this;
        try {
            var script = document.createElement('script');
            script.async = true;
            script.src = 'https://www.googletagmanager.com/gtag/js?id=' + trackId;
            script.onload = function () {
                _this.grabGtag();
                window['gtag']('js', new Date());
                window['gtag']('config', trackId);
            };
            document.head.appendChild(script);
        }
        catch (error) {
            console.error('Google Analytics loadJs error', error);
        }
    };
    GoogleAnalyticsService.grabGtag = function () {
        window['dataLayer'] = window['dataLayer'] || [];
        if (!window['gtag']) {
            window['gtag'] = function () {
                window['dataLayer'].push(arguments);
            };
        }
    };
    // wait 3 seconds to make sure the script is loaded
    GoogleAnalyticsService.checkScriptLoaded = function () {
        var _this = this;
        return new Promise(function (resolve) {
            if (_this.isScriptExist()) {
                resolve(true);
            }
            else {
                setTimeout(function () {
                    resolve(_this.isScriptExist());
                }, 3000);
            }
        });
    };
    GoogleAnalyticsService.trackPageView = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.checkScriptLoaded()];
                    case 1:
                        if ((_a.sent()) === false) {
                            console.log('Google Analytics script not fount');
                            return [2 /*return*/];
                        }
                        if (!window['gtag']) {
                            this.grabGtag();
                        }
                        url = this.handleWrongLocationPath(window.location.href);
                        console.log('url for Google Analytics', url);
                        window['gtag']('event', 'page_view', {
                            page_title: window.location.pathname,
                            page_location: url,
                            page_path: url,
                        });
                        console.log('Google Analytics trackPageView v2');
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('Google Analytics trackPageView v2 error', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    GoogleAnalyticsService.isScriptExist = function () {
        var scripts = document.getElementsByTagName('script');
        for (var i = 0; i < scripts.length; i++) {
            var src = scripts[i].getAttribute('src');
            if (src && src.includes('googletagmanager.com/gtag')) {
                return true;
            }
        }
        return false;
    };
    GoogleAnalyticsService.handleWrongLocationPath = function (url) {
        /**
         * https://itidigital.atlassian.net/jira/software/c/projects/DXP/boards/13?selectedIssue=DXP-1575
         
           Sometimes, Google Analytics records strange URL page visits, similar to the following
           the correct one looks like: http://visithighpoint.com/calendar/?imgoing-event=high-point-farmers-market-opening-day-65e76c660ce6ec59f5045937
           but sometimes it could be: http://visithighpoint.com/https://visithighpoint.com/calendar/?imgoing-event=high-point-farmers-market-opening-day-65e76c660ce6ec59f5045937?imgoing-event=high-point-farmers-market-opening-day-65e76c660ce6ec59f5045937
           or: http://visithighpoint.com/https:/visithighpoint.com/calendar/?someparames=123&imgoing-event=4s-5s-visit-all-a-flutter-butterfly-farm--6591ee7205c9a21ea6ef813c?imgoing-event=4s-5s-visit-all-a-flutter-butterfly-farm--6591ee7205c9a21ea6ef813c
        
           This method is to extract the correct part from such a URL
           */
        // Replace HTTP with HTTPS uniformly, and for the convenience of unified processing, replace all https:// with https:/, and replace back with https:// at the end of the method
        url = url.replace(/http:/g, 'https:').replace(/https:\/\//g, 'https:/');
        url = url.includes('/https') ? url.substring(url.indexOf('/https:')).substring(1) : url;
        var sp = url.split('?'); // new URLSearchParams(url);
        var newUrl = sp.splice(0, 2).join('?');
        return newUrl.replace('https:/', 'https://');
    };
    return GoogleAnalyticsService;
}());
export { GoogleAnalyticsService };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/services/google.analytics.service.ts.pre-build-optimizer.js